import { ContactWizardStepText } from "./types";

/** Naslov i objašnjenje ispod scene, po nazivu koraka. */
export const CONTACT_WIZARD_INTRO_TEXTS: Record<string, ContactWizardStepText> = {
  Detalji: {
    title: "Kreirajte novi kontakt u tren!",
    description: "Odaberite je li riječ o tvrtki ili osobi i upišite osnovne podatke. OIB i grupe olakšavaju kasnije pretraživanje.",
  },
  Osobe: {
    title: "Tko radi u tvrtki?",
    description: "Povežite osobe s kojima surađujete. Svaka osoba ostaje zaseban kontakt s vlastitim podacima.",
  },
  Email: {
    title: "Email adrese",
    description: "Dodajte jednu ili više adresa i označite primarnu. Uz svaku možete upisati kratak opis.",
  },
  Telefon: {
    title: "Brojevi telefona",
    description: "Mobitel, fiksni ili fax. Primarni broj se prikazuje prvi.",
  },
  Adrese: {
    title: "Adrese kontakta",
    description: "Sjedište, poslovnica ili adresa dostave. Primarna adresa se prikazuje prva.",
  },
  Bilješke: {
    title: "Bilješke",
    description: "Zapišite dogovore i važne pojedinosti. Važne bilješke su istaknute.",
  },
  Slike: {
    title: "Slike i dokumenti",
    description: "Dodajte logo, fotografiju ili skenirani dokument. Sve ostaje uz kontakt.",
  },
  Pregled: {
    title: "Sve na jednom mjestu",
    description: "Provjerite unesene podatke prije objave. Svaki korak možete urediti iz pregleda.",
  },
};

/** Tekst prvog koraka kad se mijenja postojeći kontakt. */
export const CONTACT_WIZARD_EDIT_TEXT: ContactWizardStepText = {
  title: "Ažurirajte podatke kontakta",
  description: "Promijenite naziv, vrstu ili grupe kontakta. Izmjene se spremaju pri prelasku na sljedeći korak.",
};

export const CONTACT_WIZARD_DEFAULT_STEP = "Detalji";

/** Primjeri koji se prikazuju dok podatak još nije upisan. */
export const CONTACT_WIZARD_SAMPLE = {
  companyName: "Adriatic Trade d.o.o.",
  personName: "Ana Horvat",
  oib: "12345678901",
  groups: ["Kupci", "Partneri"],
  representatives: [
    { name: "Ivan Kovačić", jobTitle: "Direktor" },
    { name: "Petra Babić", jobTitle: "Nabava" },
    { name: "Marko Novak", jobTitle: "Računovodstvo" },
  ],
  emails: [
    { value: "info@adriatic-trade.hr", description: "Opći upiti", primary: true },
    { value: "nabava@adriatic-trade.hr", description: "Nabava", primary: false },
    { value: "racuni@adriatic-trade.hr", description: "Računi", primary: false },
  ],
  phones: [
    { value: "+385 91 234 5678", type: "Mobitel", primary: true },
    { value: "+385 1 4567 890", type: "Fiksni", primary: false },
    { value: "+385 1 4567 891", type: "Fax", primary: false },
  ],
  addresses: [
    { line1: "Savska cesta 41", city: "10000 Zagreb", description: "Sjedište", primary: true },
    { line1: "Poljička cesta 12", city: "21000 Split", description: "Poslovnica", primary: false },
  ],
  notes: [
    { content: "Dogovoren testni najam za sljedeći tjedan.", date: "12.09.2026.", important: true },
    { content: "Preferira komunikaciju emailom.", date: "03.09.2026.", important: false },
  ],
};
